// ----------------------------------------------------------------------

const GLOW_COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];

export default function Button(theme) {
    // Contained buttons carry a glow in their own colour (Cabinet Base
    // `shadow-<color>`); it drops on hover, when the fill darkens instead.
    const glows = Object.fromEntries(
        GLOW_COLORS.map((color) => [
            `contained${color[0].toUpperCase()}${color.slice(1)}`,
            { boxShadow: theme.customShadows[color] },
        ])
    );

    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
                sizeLarge: {
                    height: theme.sizes.buttonHeightLarge,
                },
                ...glows,
                containedPrimary: {
                    'boxShadow': theme.customShadows.primary,
                    // `primary.dark` is too deep under the dark theme's
                    // contrastText; `hover` is chosen to carry it in both.
                    '&:hover': {
                        backgroundColor: theme.palette.primary.hover,
                    },
                },
                containedInherit: {
                    // The same light grey in both themes. MUI's own dark-mode
                    // fill is grey 800 — the dark paper — which left this
                    // grey 800 label invisible.
                    'color': theme.palette.grey[800],
                    'backgroundColor': theme.palette.grey[300],
                    'boxShadow': theme.customShadows.z8,
                    '&:hover': {
                        backgroundColor: theme.palette.grey[400],
                    },
                },
                outlinedInherit: {
                    'border': `1px solid ${theme.palette.border.input}`,
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                    },
                },
                textInherit: {
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                    },
                },
            },
        },
    };
}
